import * as React from "react";

import { AppBar, createStyles, Tab, Tabs, Theme, Typography, withStyles } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import meDataService from "../../services/auth/MeDataService";
import { UserRequestInfo } from "../../services/auth/UserRequestInfo";
import signaling from "../../services/site/signaling";
import { IConfigStoreProps } from "../../stores/IConfigStoreProps";
import { INavigationProps } from "../../stores/INavigationProps";

import UserProfile from "./UserProfile";

import { ChromeState } from "meet-addons-sdk";
import i18n from "../../services/localization/i18n";
import { IContextStoreProps } from "../../stores/IContextStoreProps";
import { PredefinedStoreName } from "../enums/PredefinedStoreName";

const styles = (theme: Theme) => createStyles({
    root: {
        backgroundColor: theme.palette.background.default,
        flexGrow: 1,
        height: "100%",
        marginLeft: theme.spacing(4),
    },
    rootFullScreen: {
        backgroundColor: theme.palette.background.default,
        flexGrow: 1,
        height: "100%",
        left: theme.spacing(2),
        position: "absolute",
        top: theme.spacing(4),
    },
    tabContainer: {

    },
    tabs: {
        color: theme.palette.text.primary,
    },
});

interface ITabContainerProps {
    children?: React.ReactNode;
    dir?: string;
  }

const  TabContainer = (props: ITabContainerProps) => {
    return (
      <Typography component="div" dir={props.dir} style={{ padding: 8 * 3 }}>
        {props.children}
      </Typography>
    );
  };

export interface IOptionProps {
    dir?: string;
    theme: Theme;
    classes: {
        root: string;
        rootFullScreen: string;
        tabContainer: string;
        tabs: string;
    };
}

export interface IOptionsState {
    value: number;
    user: UserRequestInfo;
}

@inject(PredefinedStoreName.CONFIG)
@inject(PredefinedStoreName.CONTEXT)
@observer
class Options extends React.Component<IOptionProps & INavigationProps &
                                      IConfigStoreProps & IContextStoreProps, IOptionsState> {

    /**
     * Creates an instance of Options.
     * @param {(IOptionProps & INavigationProps & IConfigStoreProps & IContextStoreProps)} props
     * @memberof Options
     */
    constructor(props: IOptionProps & INavigationProps & IConfigStoreProps & IContextStoreProps) {
        super(props);

        this.state = {
            user: {},
            value: 0,
        };

    }

    public render() {

        const { value } = this.state;
        const { classes, theme } = this.props;
        const { chromeState } = this.props.contextStore!;

        const root = chromeState === ChromeState.FULLSCREEN ? classes.rootFullScreen : classes.root;

        return (
            <div className={this.props.active ? root : "hidden"}>
                <AppBar position="static" color="transparent" elevation={0}>
                    <Tabs   value={value} onChange={this.onTabChanged}
                            className={classes.tabs}
                            indicatorColor="primary">
                        <Tab label={ i18n.t("options_tab_profile") } />
                    </Tabs>
                </AppBar>

                <TabContainer dir={theme.direction}>
                    <UserProfile onUserProfileChanged={this.onUserProfileChanged}
                                    onSubmit={this.onSave} />
                </TabContainer>
            </div>
        );
    }

    private onUserProfileChanged = (user: UserRequestInfo, submit?: boolean) => {

        if (!submit) {
            this.setState({user});
        } else {
            this.setState({
                user,
            }, this.onSave);
        }

    }

    private onTabChanged = (_: React.ChangeEvent<{}>, value: any) => {
        this.setState({ value });
      }

    private onSave = () => {

        const {configStore} = this.props;

        meDataService.patchAsync(this.state.user)
            .then((user) => {
                configStore!.setMe(user);

                signaling.notifyProfileChange();
            });
    }
}

export default withStyles(styles, {withTheme: true})(Options);
